import { useCallback } from 'react';
import { useShowTrialExpiredDialog } from 'shared/errors/data/useShowTrialExpiredDialog';
import { LocalStore, useLocalStore } from 'shared/helpers/Store';
import { useShowAddBillingAddressDialog } from 'shared/modules/subscription/core/useShowAddBillingAddressDialog';
import { useLoadboardAccess } from './LoadboardAccessAPI';

export function useLoadboardAccessState() {
  const { data } = useLoadboardAccess();
  const { isOpenUpgradeWarningDialog } = useShowAddBillingAddressDialog();
  const { isOpenTrialExpiredDialog } = useShowTrialExpiredDialog();
  const hasSeenAccessPopup = useLocalStore('has_seen_access_popup') === 'true';

  const isPausedVerificationProcess =
    data?.verification_status === 'reviewed' ||
    data?.verification_status === 'non_verifiable';

  const isSubscriptionExpiredOpen =
    Boolean(isOpenUpgradeWarningDialog) || Boolean(isOpenTrialExpiredDialog);

  const isOpen =
    data?.access === 'limited' &&
    !isPausedVerificationProcess &&
    !hasSeenAccessPopup &&
    !isSubscriptionExpiredOpen;

  const close = useCallback(() => {
    LocalStore.set('has_seen_access_popup', 'true');
  }, []);

  return [isOpen, close] as const;
}
